<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Chat for Admins
        <small></small>
      </h1>

    </section>

    <!-- Main content -->
    <section class="content admin-chat">
      <div class="row">
              <div class="col-md-9">

                  <!-- message list -->
                  <transition name="slide-fade">
                      <div class="box">
                          <div class="messages">
                              <ul>
                                  <li v-for="msg in messages">
                                      <div class="media-content">
                                          <div class="">
                                              <p>
                                                  <strong>{{decoded(msg.user)}}</strong> <small>{{msg.date}}</small>
                                                  <br>
                                                  {{msg.text}}
                                              </p>
                                          </div>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                          <!-- inputs new message -->
                          <div class="controls field has-addons">
                              <div class="control is-expanded">
                                  <input v-model="message" v-on:keydown.enter="sendMessage()" class="input is-primary" placeholder="Write message" autofocus>
                              </div>
                              <div class="control">
                                  <button v-on:click="sendMessage()" :disabled="message == ''" class="button is-primary">Send</button>
                              </div>
                          </div>
                      </div>
                  </transition>
              </div>

              <!-- user list -->
              <div class="col-md-3">
                  <div>
                      <h4 class="title is-4">Current users ({{users.length}})</h4>
                      <ul>
                          <li v-for="user in users">
                              <div class="media-content">
                                  <div class="">
                                      <p>
                                          <strong>{{decoded(user.name)}}</strong>
                                      </p>
                                  </div>
                              </div>
                          </li>
                      </ul>
                  </div>
              </div>
      </div>
      <br />

    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Admin',
    data: function () {
      return {
        role: 1,
        userName: '',
        message: ''
      }
    },
    computed: {
      ...mapState({
        // arrow functions can make the code very succinct!
        messages: state => state.chat.messages,
        users: state => state.chat.users
      })
    },
    methods: {
      decoded: function (encoded) {
        if (encoded === '') {
          return ''
        }
        try {
          return decodeURI(encoded)
        } catch (err) {
          return encoded
        }
      },
      sendMessage: function () {
        if (this.message.length > 0) {
          this.$socket.emit('send-msg', { message: this.message, user: this.userName })
          this.message = ''
        }
      },
      scrollToEnd: function () {
        var container = this.$el.querySelector('.messages')
        container.scrollTop = container.scrollHeight
      }
    },
    mounted: function () {
      // setTimeout(function () {
      if (this.$store.state.nickname != null) {
        this.userName = this.$store.state.nickname
      } else {
        this.userName = 'Admin 03'
      }
      this.$socket.emit('add-user', this.userName)
      // }, 500)
    },
    updated () {
      this.scrollToEnd()
    }
  }
</script>

<style scoped>
    .messages{
        overflow: auto;
        height: calc( 100vh - 200px);
    }
    .messages li {
        padding: 5px;
    }
    .messages li:nth-child(even)  {
        background: #fff;
    }
    .messages li:nth-child(odd)  {
        background: #f4f4f4;
    }
    .controls{
        padding-top: 5px;
    }


    .fades-leave-to {
        transition: opacity .5s
    }

    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
    /* width */
    ::-webkit-scrollbar {
        width: 4px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    @media screen and (max-width: 992px) {
    }
    @media screen and (max-width: 768px) {
    }
    @media screen and (max-width: 480px) {
    }

    /* Bulma */
    .box {
        background-color: white;
        border-radius: 5px;
        -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
        color: #4a4a4a;
        display: block;
    }
    .admin-chat {

    }
    .admin-chat ul {
        list-style: none;
    }
    .admin-chat p, .admin-chat ul {
        margin: 0;
        padding: 0;
    }
    .media-content {
        -ms-flex-preferred-size: auto;
        flex-basis: auto;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -ms-flex-negative: 1;
        flex-shrink: 1;
        text-align: left;
    }
    .field.has-addons {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
    }
    .controls {
        padding-top: 5px;
    }
    .control {
        font-size: 1rem;
        position: relative;
        text-align: left;
    }
    .field.has-addons .control.is-expanded {
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
    }

    .input, .textarea {
        -moz-appearance: none;
        -webkit-appearance: none;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border: 1px solid transparent;
        border-radius: 3px;
        -webkit-box-shadow: none;
        box-shadow: none;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        font-size: 16px;
        height: 30px;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        line-height: 1.5;
        padding-bottom: calc(0.375em - 1px);
        padding-left: calc(0.625em - 1px);
        padding-right: calc(0.625em - 1px);
        padding-top: calc(0.375em - 1px);
        position: relative;
        vertical-align: top;
        background-color: white;
        border-color: #dbdbdb;
        color: #363636;
        -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
        box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
        max-width: 100%;
        width: 100%;
    }
    .field.has-addons .control:not(:last-child) {
        margin-right: -1px;
    }
    .field.has-addons .control .button, .field.has-addons .control .input, .field.has-addons .control .select select {
        border-radius: 0;
    }
    .field.has-addons .control:first-child .button, .field.has-addons .control:first-child .input, .field.has-addons .control:first-child .select select {
        border-bottom-left-radius: 3px;
        border-top-left-radius: 3px;
    }
    .input.is-primary, .textarea.is-primary {
        border-color: #00d1b2;
    }
    .button {
        -moz-appearance: none;
        -webkit-appearance: none;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border: 1px solid transparent;
        border-radius: 3px;
        -webkit-box-shadow: none;
        box-shadow: none;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        font-size: 16px;
        height: 30px;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        line-height: 1.5;
        position: relative;
        vertical-align: top;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: white;
        border-color: #dbdbdb;
        color: #363636;
        cursor: pointer;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding-left: 0.75em;
        padding-right: 0.75em;
        text-align: center;
        white-space: nowrap;
    }
    .button.is-primary {
        background-color: #00d1b2;
        border-color: transparent;
        color: #fff;
    }
    .button[disabled] {
        background-color: white;
        border-color: #dbdbdb;
        -webkit-box-shadow: none;
        box-shadow: none;
        opacity: 0.5;
    }
    .button.is-primary[disabled] {
        background-color: #00d1b2;
        border-color: transparent;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .title {
        color: #363636;
        font-size: 2rem;
        font-weight: 600;
        line-height: 1.125;
    }
    .title:not(:last-child), .subtitle:not(:last-child) {
        margin-bottom: 1.5rem;
    }
    .title.is-4 {
        font-size: 1.5rem;
    }
    .admin-chat hr {
        padding: 0;
        margin: 0;
    }
</style>



// WEBPACK FOOTER //
// Admin.vue?41ad656e